import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_CONFIG } from './config';

const isMissingConfig = !OKTA_CONFIG.issuer || !OKTA_CONFIG.clientId;

if (isMissingConfig) {
  console.warn(
    '[okta] VITE_OKTA_ISSUER / VITE_OKTA_CLIENT_ID are not set. Sign-in will fail until both are configured.',
  );
}

export const oktaAuth = new OktaAuth({
  issuer: OKTA_CONFIG.issuer || 'https://placeholder.okta.com/oauth2/default',
  clientId: OKTA_CONFIG.clientId || 'placeholder',
  redirectUri: OKTA_CONFIG.redirectUri,
  postLogoutRedirectUri: OKTA_CONFIG.postLogoutRedirectUri,
  scopes: OKTA_CONFIG.scopes,
  pkce: true,
});

/** True when the OIDC config is incomplete — callers should skip network ops. */
export const oktaConfigMissing = isMissingConfig;
